import { config } from "config";
import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { BackButton } from "components/grid";
import { Icon, IconsEnum } from "components/icon/Icon";
import { CustomerDetailsPlacement } from "constants/customer-details";
import { trackEngagement } from "helpers/analytics";
import { normalizeAssetUrl } from "helpers/url";
import { ISelectedWidget } from "interfaces/customerDetailsWidgetInterface";
import { withVar } from "themes/helpers";

import { KbWidgetIcon } from "./KbWidgetIcon";
import { BackButtonContainer, CloseButtonContainer, StyledContainer, StyledWidget, WidgetsContainer } from "./styles";

interface IProps {
  widgets: ISelectedWidget[];
  selectedWidgetId: string;
  hasCloseButton?: boolean;
  onChangeSelectedWidget(widgetId: string): void;
  onClose?(e: React.MouseEvent<HTMLElement>): void;
  placement?: CustomerDetailsPlacement;
}

export const CustomerDetailsWidgetIcons: FC<IProps> = ({
  widgets,
  selectedWidgetId,
  hasCloseButton = true,
  onChangeSelectedWidget,
  onClose,
  placement,
}) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onWidgetClick = (widgetId: string, widgetName?: string) => {
    if (isWidgetSelected(widgetId)) return;

    trackEngagement("Ticket details: Application tab clicked", placement, { app: widgetName });
    onChangeSelectedWidget(widgetId);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const isWidgetSelected = (widgetId: string) => {
    return selectedWidgetId === widgetId;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClose = (e: React.MouseEvent<HTMLElement>) => {
    onClose?.(e);
  };

  return (
    <StyledContainer>
      <BackButtonContainer>
        <BackButton onClick={handleClose} style={{ margin: 0 }} />
      </BackButtonContainer>
      {hasCloseButton && (
        <CloseButtonContainer onClick={handleClose}>
          <Icon
            name={IconsEnum.Close}
            height="18px"
            width="18px"
            inline
            fill={withVar(DesignToken.ActionPrimaryDefault)}
          />
        </CloseButtonContainer>
      )}
      <WidgetsContainer>
        {widgets.map((widget: ISelectedWidget) => {
          const commonProps = {
            isSelected: isWidgetSelected(widget.id),
            onClick: () => onWidgetClick(widget.id, widget.name),
            iconUrl: widget.icon ? normalizeAssetUrl(widget.icon) : undefined,
            className: "with-icon",
          } as const;

          return widget.appId === config.knowledgebaseWidgetAppId ? (
            <KbWidgetIcon key={widget.id} {...commonProps} />
          ) : (
            <StyledWidget key={widget.id} {...commonProps} />
          );
        })}
      </WidgetsContainer>
    </StyledContainer>
  );
};
